<!--
frontend-author:udayasankar,
backend-author: ,
page-name :Sales by Item.vue,
page-description :Sales by Item for invoice,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<!-- Html code for Sales by Item-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="10" lg="10" md="10" sm="10" class="px-0">
        <GlobalDateRangePicker
          class="pr-3"
          ref="daterangeupdate"
          :singleDatePicker="false"
          v-on:setDateRange="getDateRange($event,1)"
          :fromDate="from_date"
          :toDate="to_date"
        />
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown mb-xs">
          <template slot="button-content">
            <span v-if="selectedfilter.filter_name">
              <i class="fa fa-filter la-lg mr-1"></i>
              {{selectedfilter.filter_name}}
            </span>
            <span v-else>
              <i class="la la-cog la-lg mr-1"></i>Customize Report
            </span>
          </template>

          <b-dropdown-item v-b-modal.salesitem>General</b-dropdown-item>
          <b-dropdown-item v-b-modal.custom_index>Show/hide columns</b-dropdown-item>

          <template v-if="reportsfilter.length>0">
            <b-dropdown-divider />
            <div class="mb-2">
              <span class="pl-4 text-link fw-semi-bold">Your Custom Filters</span>
            </div>
          </template>
          <b-dropdown-item v-for="item in reportsfilter" :key="item.id">
            <div class="d-flex">
              <a
                class="report_button mb-0 w-75 text-truncate"
                @click="runcustomreport(item)"
              >{{ item.filter_name }}</a>
              <i
                class="la la-edit la-lg text-right ml-2 mr-3 ml-auto"
                @click="filterpage = 'update',filteritems=item"
                v-b-modal.savefilterform
              ></i>
              <i
                class="glyphicon glyphicon-trash text-right"
                @click="handlingapprovingmodal({
                  content : 'Are you sure you want to delete this customize filter ?',
                  title : 'Delete customize filter - '+item.filter_name,
                  module:'general/deletecustomfilter',
                  data:JSON.stringify({
                    id : item.filter_id,
                    report_type: $route.meta.title
                  }),
                  RoutePlace:'',
                  isRoute:'false',
                  type: 'delete'
                })"
              ></i>
            </div>
          </b-dropdown-item>
        </b-dropdown>
        <span
          class="btn-link cursor_pointer ml-2 fw-semi-bold"
          v-if="!selectedfilter.filter_id"
          @click="filterpage = 'create',savefilterform()"
        >Save filter</span>
        <!-- <b-button variant="light" class="text-left" v-b-modal.salesitem>Customize Report</b-button> -->
      </b-col>

      <b-col xl="2" lg="2" md="2" sm="2" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown float-right mr-2">
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item @click="exportModal()" class="dropdown-no-btn">
            <span class="la la-download mx-2"></span>Export sales by Product
          </b-dropdown-item>
        </b-dropdown>
        <!-- <b-button-group size="sm" class="float-right">
          <b-button variant="light" title="CSV Export">
            <i class="fa fa-upload"></i>
          </b-button>
          <b-button variant="light" title="PDF Export">
            <i class="fa fa-file-pdf-o"></i>
          </b-button>
          <b-button variant="light" title="Print">
            <i class="fa fa-print"></i>
          </b-button>
          <router-link :to="{name:'Reports'}" class="ml-2">
            <i class="la la-times la-lg ver-align"></i>
          </router-link>
        </b-button-group>-->
      </b-col>
    </b-row>
    <div>
      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{ org_name }}</p>
            <h4 class="fw-semi-bold">Sales by Product</h4>
            <p
              class="text-sm text-muted mb-2"
            >{{ 'From ' + getDateFormat(from_date) +' To '+ getDateFormat(to_date) }}</p>
          </div>
          <div class="table-responsive" id="reportScrollCol">
            <!--  sales by customer Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  sales by customer Table head-->
              <thead class="tbl-col">
                <tr>
                  <th style="width:170px !important">
                    <router-link
                      :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'pdt_name'} }"
                      class="text-dark text-decoration-none"
                    >
                      PRODUCT
                      <small class="text-muted" v-if="label == 'pdt_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:100px !important">
                    <router-link
                      :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'pdt_sku'} }"
                      class="text-dark text-decoration-none"
                    >
                      SKU
                      <small class="text-muted" v-if="label == 'pdt_sku'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'total_pdt_qty'} }"
                      class="text-dark text-decoration-none"
                    >
                      Quantity
                      <small class="text-muted" v-if="label == 'total_pdt_qty'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'subtotal_without_tax'} }"
                      class="text-dark text-decoration-none"
                    >
                      SUBTOTAL
                      <small class="text-muted" v-if="label == 'subtotal_without_tax'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'total_discount'} }"
                      class="text-dark text-decoration-none"
                    >
                      DISCOUNT
                      <small class="text-muted" v-if="label == 'total_discount'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'total_tax'} }"
                      class="text-dark text-decoration-none"
                    >
                      TAX
                      <small class="text-muted" v-if="label == 'total_tax'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="width:140px !important" class="text-right">
                    <router-link
                      :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'subtotal_with_tax'} }"
                      class="text-dark text-decoration-none"
                    >
                      TOTAL
                      <small class="text-muted" v-if="label == 'subtotal_with_tax'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th
                    v-for="(column) in reported_columns"
                    v-if="column.checked == true"
                    :key="column.id"
                    :style="{'width':column.colWidth+'px !important'}"
                    :class="{'text-right':column.field=='total_avg_amt'}"
                  >
                    <span :style="{'width':column.colWidth+'px !important'}">
                      <router-link
                        :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: show,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort == 'asc' ? 'desc' : 'asc' ,label:column.field} }"
                        class="text-dark text-decoration-none"
                      >
                        {{column.title }}
                        <small class="text-muted" v-if="label == column.field">
                          <i
                            :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </span>
                  </th>
                </tr>
              </thead>
              <!--  Sales by Customer Table body and data -->
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="9" class="text-center">No data to display</td>
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="item in lists" :key="item.pdt_id" @click="oldRoute = $route.query">
                    <td style="width:170px !important">
                      <router-link
                        v-if="RoutePermission(true,'ProductView','','','')"
                        class="event-link theme-text-color"
                        :to="{ name : 'ProductView',params:{id:item.pdt_id}}"
                      >
                        <span class="text">{{ item.pdt_name }}</span>
                      </router-link>
                      <template v-else>
                        <span class="text">{{ item.pdt_name }}</span>
                      </template>
                    </td>
                    <td style="width:100px !important">
                      <span class="text">{{ item.pdt_sku }}</span>
                    </td>
                    <td class="text-right">
                      <router-link
                        class="event-link"
                        :to="{ name : 'SalesItemFilter',params:{id:item.pdt_id},query: {name:item.pdt_name,id:item.pdt_id,sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                      >{{ Number(item.total_pdt_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesItemFilter',params:{id:item.pdt_id},query: {id:item.pdt_id,name:item.pdt_name,sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                        class="event-link"
                      >{{ orgCurrencySymbol+" "+Number(item.subtotal_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesItemFilter',params:{id:item.pdt_id},query: {id:item.pdt_id,name:item.pdt_name,sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                        class="event-link"
                      >{{ orgCurrencySymbol+" "+Number(item.total_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        class="event-link"
                        :to="{ name : 'SalesItemFilter',params:{id:item.pdt_id},query: {id:item.pdt_id,name:item.pdt_name,sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                      >{{ orgCurrencySymbol+" "+Number(item.total_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>
                    <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesItemFilter',params:{id:item.pdt_id},query: {id:item.pdt_id,name:item.pdt_name,sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom} }"
                        class="event-link"
                      >{{ orgCurrencySymbol+" "+Number(item.subtotal_with_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>

                    <!-- <td class="text-right">
                      <router-link
                        :to="{ name : 'SalesItemFilter',query: {pdt_id:item.pdt_id,pdt_name:item.pdt_name,sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10} }"
                        class="text-dark text-decoration-none"
                      >{{ orgCurrencySymbol+" "+Number(item.total_avg_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </td>-->
                    <td
                      v-for="(column) in reported_columns"
                      v-if="column.checked == true"
                      :key="column.id"
                      :style="{'width':column.colWidth+'px !important'}"
                      :class="{'text-right':column.align=='right'}"
                    >
                      <span
                        v-if="column.field=='pdt_state'"
                      >{{item.pdt_state == '1'? 'Goods':'Service'}}</span>
                      <span
                        v-if="column.field=='total_avg_amt'"
                      >{{orgCurrencySymbol+" "+item[column.field]}}</span>

                      <span
                        :class="{'text':column.align=='overflow'}"
                        v-else-if="column.field!='pdt_state'"
                      >{{item[column.field] }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="fw-semi-bold text-right">TOTAL ({{total_count}})</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ Number(total_amount.pdt_total_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_subtotal_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_view_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_view_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td
                      class="fw-semi-bold text-right"
                    >{{ orgCurrencySymbol+" "+Number(total_amount.total_subtotal_with_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <!-- <td class="fw-semi-bold text-right"></td> -->
                    <td
                      v-if="reported_columns.length > 0 && show_columns_length > 0"
                      :colspan="parseInt(reported_columns.length) - 0"
                    ></td>
                    <!-- <td class="fw-semi-bold text-right"></td> -->
                  </tr>
                </template>
              </tbody>
            </table>
            <p class="ml-4" v-if="lists.length != 0">
              Amount is displayed in your base currency
              <b-badge variant="success" size="xs" style="height:20px">{{orgCurrency}}</b-badge>
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Sales by Item pagination and data showing -->
    <b-row
      v-if="lists.length > 0 || arrow"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav v-if="lists.length > 0" class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span
              class="btn-group dropdown"
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 25,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: 50,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#reportScrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#reportScrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="show<total_count">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort,label:label} }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort,label:label} }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort,label:label} }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort,label:label } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: Math.ceil(total_count / count),show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort,label:label } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'SalesItem',query: {sales_tags:$route.query.sales_tags,sales_person:$route.query.sales_person,from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,sort:sort,label:label } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <!--  Model-->
    <b-modal
      id="salesitem"
      title="Customize Report"
      body-class="bg-white"
      size="lg"
      ok-title="Run Report"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      cancel-variant="light"
      ref="runreport"
      @shown="displayvalue()"
    >
      <!-- Validation for salescustomer reports -->
      <b-row>
        <b-col xl="12" lg="12" md="12" xs="12" sm="12">
          <div class="container-fluid">
            <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
              <button type="button" @click="error_show=!error_show" class="close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div v-for="(item,index) in items" :key="index">
                <p
                  class="text-danger"
                  v-if="errors.has('filter_matching['+index+']')"
                >Row {{ index + 1 }} : Please enter the matching type</p>
                <p
                  class="text-danger"
                  v-if="errors.has('cust_name['+index+']')"
                >Row {{ index + 1 }} : Please enter the customize name</p>
                <p
                  class="text-danger"
                  v-if="errors.has('type['+index+']')"
                >Row {{ index + 1 }} : Please enter customize type</p>
                <p
                  class="text-danger"
                  v-if="errors.has('value['+index+']')"
                >Row {{ index + 1 }} : Please enter customize value</p>
              </div>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
              <b-form-group label="Date" label-for="date" :label-cols="2">
                <GlobalDateRangePicker
                  class="pl-4"
                  :singleDatePicker="false"
                  v-on:setDateRange="getDateRange($event)"
                  :fromDate="from_date"
                  :toDate="to_date"
                />
                <input type="hidden" name="from_date" v-model.trim="from_date" />
                <input type="hidden" name="to_date" v-model.trim="to_date" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="6" lg="6" md="6" sm="6" xs="6">
              <b-form-group label="Tag List" label-for="taglist" :label-cols="5">
                <b-form-select class="form-control" v-model.trim="sales_tags">
                  <option></option>
                  <option
                    v-for="item in taglist.sales_tags"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="6" xs="6">
              <b-form-group label="Sales Person" label-for="salespersonlist" :label-cols="5">
                <b-form-select class="form-control" v-model.trim="sales_person">
                  <option></option>
                  <option
                    v-for="item in taglist.sales_person"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group label="Advanced Filters" label-for="adv-filter" :label-cols="5" />
          <b-row v-for="(item,index) in items" :key="index">
            <b-col xl="2" lg="2" md="2" sm="2" xs="2">
              <b-form-group>
                <b-form-select
                  class="form-control"
                  v-model.trim="item.filter_matching"
                  v-validate="'required'"
                  :name="'filter_matching['+index+']'"
                  v-if="index > 0"
                >
                  <option value="and">And</option>
                  <option value="or">Or</option>
                </b-form-select>
                <input
                  type="text"
                  v-else
                  class="form-control"
                  v-model.trim="item.filter_matching"
                  v-validate="'required'"
                  :name="'filter_matching['+index+']'"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="5" md="5" sm="5" xs="5">
              <b-form-group>
                <b-form-select
                  class="form-control"
                  v-model.trim="item.field"
                  v-validate="'required'"
                  :name="'cust_name['+index+']'"
                  @change="item.value = ''"
                >
                  <option value="cus_id">Customer Name</option>
                  <option value="pdt_name">Product Name</option>
                  <option value="pdt_sku">Product sku</option>
                  <option value="pdt_tags">Product tags</option>
                  <!-- <optgroup label="Reporting Tags" v-if="reporting_tags.length!=0">
                    <option
                      v-for="(tag,index) in reporting_tags"
                      :key="index"
                      :value="tag.tag_column_name"
                    >
                      <div @click="addNewRow()">{{tag.tag_name}}</div>
                    </option>
                  </optgroup>-->
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="5" md="5" sm="5" xs="5">
              <b-form-group>
                <b-form-select
                  class="form-control"
                  v-model.trim="item.comparator"
                  v-validate="'required'"
                  :name="'type['+index+']'"
                >
                  <option value="1" v-if="item.field !='pdt_tags'">Is</option>
                  <option value="2" v-if="item.field !='pdt_tags'">Is not</option>
                  <option
                    value="5"
                    v-if="item.field !='cus_id' && item.field !='pdt_tags'&& item.field !='pdt_tags'"
                  >Starts with</option>
                  <option
                    value="6"
                    v-if="item.field !='cus_id' && item.field !='pdt_tags'&& item.field !='pdt_tags'"
                  >Ends with</option>
                  <option
                    value="7"
                    v-if="item.field !='cus_id' && item.field !='pdt_tags'&& item.field !='pdt_tags'"
                  >Contains</option>
                  <option
                    value="8"
                    v-if="item.field !='cus_id' && item.field !='pdt_tags'&& item.field !='pdt_tags'"
                  >Does not contains</option>
                  <option value="10" v-if="item.field =='pdt_tags'">In</option>
                  <option value="11" v-if="item.field =='pdt_tags'">Not In</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xl="3" lg="5" md="5" sm="5" xs="5" @click="removecustomer($event,index)">
              <b-form-group>
                <vue-bootstrap-typeahead
                  @input="customerlist($event,index)"
                  v-model="item.cus_detail_id"
                  :id="'customer_search_'+index"
                  name="cus_detail_id[]"
                  :data="item.customers"
                  :class="{'mr-3':true,'customer_search':true}"
                  :serializer="customer => customer.label"
                  @hit="checkCustomer($event,index)"
                  placeholder="Type to search customer"
                  :ref="'cus_name_typeahead_'+index"
                  v-show="item.field =='cus_id'"
                />
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="item.value"
                  v-if="item.field != 'pdt_tags'&& item.field !='pdt_tags'"
                  v-show="item.field !='cus_id'"
                  v-validate="'required'"
                  :name="'value['+index+']'"
                />
                <b-form-select
                  class="form-control"
                  v-model.trim="item.value"
                  v-if="item.field == 'pdt_tags'"
                >
                  <option
                    v-for="item in taglist.pdt_tags"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</option>
                </b-form-select>
                <!-- <b-form-select
                  class="form-control"
                  v-model.trim="item.value"
                  v-if="is_report_tag[index].option==1"
                >
                  <option
                    v-for="item in is_report_tag[index].options"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</option>
                </b-form-select>-->
              </b-form-group>
            </b-col>
            <b-col xl="1" lg="1" md="1" sm="1" xs="1">
              <b-form-group>
                <span>
                  <i class="glyphicon glyphicon-trash" @click="removeRow(index)"></i>
                </span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="12" md="12" lg="12" sm="12" xs="12">
          <span
            class="text-link cursor_pointer fw-semi-bold"
            @click="addNewRow()"
            v-if="items.length<10"
          >+ Add more</span>
          <span v-else>
            <i class="fa fa-exclamation-triangle pr-3 pl-2 text-warning fa-md"></i>
            Filter conditions must be within ten criteria
          </span>
        </b-col>
      </b-row>
      <!-- <div class="footer">
        <b-row>
          <b-col xl="12" lg="12" md="12" sm="12">
            <b-button variant="primary" @click="onRunReport" class="float-right ml-3">Run Report</b-button>
            <b-button variant="default" @click="closeModal('runreport')" class="float-right">Cancel</b-button>
          </b-col>
        </b-row>
      </div>-->
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="custom_index"
      title="Customize Report"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Run Report"
      size="md"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      ref="run"
    >
      <b-row>
        <b-col>
          <p class="fw-semi-bold">Product</p>
          <b-form-checkbox
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:25px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
      </b-row>
    </b-modal>
    <SaveFilterForm :saveforfuture="saveforfuture" :page="filterpage" :item="filteritems" />
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
    />
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Sales by Product'"
      @downloaded="export_modal=false"
    />
  </div>
</template>
<!-- Sales by Item  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll

import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import Vue from "vue";
import moment from "moment";
import $ from "jquery";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { formatDate } from "@/mixins/formatDate";
import SaveFilterForm from "@/pages/Reports/SaveFilterForm";
function getPageSalesByProducts(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchProductLists", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    label: [String, Number],
    sort: [String, Number]
  },
  name: "SalesProduct",
  components: {
    VueBootstrapTypeahead,
    SaveFilterForm
  },
  mixins: [formatDate, scrollTable],
  data() {
    return {
      // is_report_tag: [],
      export_data: [],
      export_modal: false,
      psort: this.sort,
      plabel: this.label,
      arrow: false,
      export_xl: {
        PRODUCT: "pdt_name",
        SKU: "pdt_sku",
        QUANTITY: "total_pdt_qty",
        SUBTOTAL: "subtotal_without_tax",
        DISCOUNT: "total_discount",
        TAX: "total_tax",
        TOTAL: "subtotal_with_tax"
        // AVERAGE: "total_avg_amt"
      },
      show_columns: [],
      show_columns_length: 0,
      reported_columns: [],
      available_columns: [
        {
          Group: "product",
          field: "pdt_state",
          title: "Type",
          checked: false,
          colWidth: 75,
          align: ""
        },
        {
          Group: "product",
          field: "total_avg_amt",
          title: "Average",
          checked: false,
          colWidth: 140,
          align: "right"
        },

        {
          Group: "product",
          field: "pdt_legacy_id",
          title: "Customer ID",
          checked: false,
          colWidth: 150,
          align: ""
        },
        {
          Group: "product",
          field: "pdt_desc",
          title: "Product Description",
          checked: false,
          colWidth: 200,
          align: "overflow"
        },
        {
          Group: "unit_type",
          field: "pdtunit_name",
          title: "Unit",
          checked: false,
          colWidth: 75,
          algin: ""
        }
      ],
      error_show: false,
      columns: this.$route.query.show_columns,
      items: [],
      sales_tags: this.$route.query.sales_tags || "",
      sales_person: this.$route.query.sales_person || "",
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),
      Selected: "",
      org_name: this.$AppDetails.organization.comp_name || "",
      saveforfuture: {},
      filterpage: "create",
      filteritems: "",
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: ""
    };
  },
  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  methods: {
    async savefilterform() {
      this.saveforfuture = await {
        from_date: this.from_date,
        to_date: this.to_date,
        label: this.label,
        sort: this.sort,
        sales_tags: this.sales_tags,
        sales_person: this.sales_person,
        show_columns: this.show_columns,
        available_columns: this.available_columns,
        items: this.items
      };
      await this.$root.$emit("bv::show::modal", "savefilterform");
    },
    displayvalue() {
      for (var i = 0; i <= this.items.length; i++) {
        this.$refs["cus_name_typeahead_" + i][0].inputValue = this.items[
          i
        ].cus_detail_id;
        //  mask and remover
        $("#customer_search_" + i + " input").css("pointer-events", "none");
        $("#customer_search_" + i + " input").css(
          "background-color",
          "#f7f7f7"
        );
        $("#customer_search_" + i + " input").css("position", "relative");
        $("#customer_search_" + i + " .input-group").append(
          "<span class='la la-close p-2' id='customer_remove_" + i + "'></span>"
        );
        $("#customer_remove_" + i).css("position", "absolute");
        $("#customer_remove_" + i).css("right", "0");
      }
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchProductExportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,
          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });
      return response;
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    closeModal(id) {
      this.$refs[id].hide();
    },

    removecustomer(e, index) {
      if (e.target.matches("#customer_remove_" + index)) {
        $("#customer_search_" + index + " input").css("pointer-events", "all");
        $("#customer_search_" + index + " input").css(
          "background-color",
          "#fff"
        );
        $("#customer_search_" + index + " input").css("position", "");
        $("#customer_remove_" + index).remove();
        var cus_name = "cus_name_typeahead_" + index;
        this.$refs[cus_name][0].inputValue = "";
        this.items[index].value = "";
      }
    },
    checkCustomer(event, index) {
      $("#customer_search_" + index + " input").css("pointer-events", "none");
      $("#customer_search_" + index + " input").css(
        "background-color",
        "#f7f7f7"
      );
      $("#customer_search_" + index + " input").css("position", "relative");
      $("#customer_search_" + index + " .input-group").append(
        "<span class='la la-close p-2' id='customer_remove_" +
          index +
          "'></span>"
      );
      $("#customer_remove_" + index).css("position", "absolute");
      $("#customer_remove_" + index).css("right", "0");
      this.items[index].value = event.value;
    },
    // findFieldOption(ev, index) {
    //   if (
    //     ev == "cus_id" ||
    //     ev == "pdt_name" ||
    //     ev == "pdt_sku" ||
    //     ev == "pdt_tags"
    //   ) {
    //     this.is_report_tag[index].option = 0;
    //   } else {
    //     this.is_report_tag[index].option = 1;
    //     this.is_report_tag[index].options = this.reporting_tags.filter(
    //       x => x.tag_column_name == ev
    //     )[0].tag_options;
    //   }
    // },
    addNewRow() {
      // this.is_report_tag.push({ option: "", options: [] });
      this.items.push({
        filter_matching: "",
        customers: [],
        cus_detail_id: "",
        field: "",
        comparator: "",
        value: ""
      });
      this.items[0].filter_matching = "When";
    },
    customerlist(event, index) {
      if (event != "") {
        store.dispatch("general/fetchCustomerData", event).then(() => {
          this.items[index].customers = this.customer_filter_list;
        });
      }
    },
    runcustomreport(item) {
      this.selectedfilter = item;
      var filter_content = JSON.parse(item.filter_content);
      this.from_date = filter_content.from_date;
      this.to_date = filter_content.to_date;
      this.plabel = JSON.parse(JSON.stringify(filter_content.label));
      this.psort = JSON.parse(JSON.stringify(filter_content.sort));
      this.sales_tags = filter_content.sales_tags;
      this.sales_person = filter_content.sales_person;
      this.show_columns = filter_content.show_columns;
      this.available_columns = filter_content.available_columns;
      this.items = filter_content.items;
      this.onRunReport(0);
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    onRunReport(runreport) {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (runreport == 0 && this.$refs.daterangeupdate) {
            var child = this.$refs.daterangeupdate;
            child.checkConsole({
              startDate: this.from_date,
              endDate: this.to_date
            });
          }
          this.reported_columns = JSON.parse(
            JSON.stringify(this.available_columns)
          );
          this.show_columns_length = JSON.parse(
            JSON.stringify(this.show_columns)
          ).length;
          //To add export for selected columns
          for (var i = 0; i < this.reported_columns.length; i++) {
            if (this.reported_columns[i].checked == true) {
              this.export_xl[
                this.reported_columns[i].title
              ] = this.reported_columns[i].field;
            } else {
              delete this.export_xl[this.reported_columns[i].title];
            }
          }

          this.$router.push({
            name: this.$route.name,
            query: {
              from_date: this.from_date,
              to_date: this.to_date,
              label: $.isEmptyObject(this.selectedfilter)
                ? this.label
                : this.plabel,
              sales_tags: this.sales_tags,
              sales_person: this.sales_person,
              sort: $.isEmptyObject(this.selectedfilter)
                ? this.sort
                : this.psort,
              select_columns: JSON.stringify({
                columns: JSON.stringify(this.show_columns)
              }),
              custom: JSON.stringify({
                columns: JSON.stringify(this.items)
              })
            }
          });
        } else {
          this.error_show = true;
        }
      });
    },
    getDateRange(event, runreport) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      if (runreport == 1) {
        this.onRunReport();
      }
    },
    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    },
    removeRow(index) {
      var i;
      if (typeof this.items[parseInt(index) + 1] != "undefined") {
        for (i = index; i < this.items.length - 1; i++) {
          var cus_name = "cus_name_typeahead_" + i;
          this.$refs[cus_name][0].inputValue = this.items[i + 1].cus_detail_id;
        }
      }
      this.items.splice(index, 1);
      this.items.splice(index, 1);
      if (typeof this.items[parseInt(index)] != "undefined") {
        this.items[0].filter_matching = "When";
      }
    }
  },

  created() {
    // this.from_date = this.$route.query.from_date;
    // this.to_date = this.$route.query.to_date;
    if (!$.isEmptyObject(this.selectedfilter)) {
      this.runcustomreport(this.selectedfilter);
    } else if (
      Object.entries(this.$route.query).length === 0 &&
      this.$route.query.constructor === Object
    ) {
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          label: this.label,
          sales_tags: this.sales_tags,
          sales_person: this.sales_person,
          sort: this.sort,
          select_columns: JSON.stringify({
            columns: JSON.stringify(this.show_columns)
          }),
          custom: JSON.stringify({
            columns: JSON.stringify(this.items)
          })
        }
      });
    }
    if (
      typeof this.$route.query.custom != "undefined" &&
      this.$route.query.custom != null
    ) {
      this.from_date = this.$route.query.from_date;
      this.to_date = this.$route.query.to_date;
      this.columns = this.$route.query.show_columns;

      this.items =
        Object.entries(JSON.parse(this.$route.query.custom)).length === 0 &&
        JSON.parse(this.$route.query.custom).constructor === Object
          ? []
          : JSON.parse(JSON.parse(this.$route.query.custom)["columns"]);
    }
  },
  mounted: function() {
    var index;
    for (index = 0; index < this.items.length; index++) {
      var cus_name = "cus_name_typeahead_" + index;
      if (
        typeof this.$refs[cus_name] != "undefined" &&
        this.items[index].field == "cus_id"
      ) {
        $("#customer_search_" + index + " input").css("pointer-events", "none");
        $("#customer_search_" + index + " input").css(
          "background-color",
          "#f7f7f7"
        );
        $("#customer_search_" + index + " input").css("position", "relative");
        $("#customer_search_" + index + " .input-group").append(
          "<span class='la la-close p-2' id='customer_remove_" +
            index +
            "'></span>"
        );
        $("#customer_remove_" + index).css("position", "absolute");
        $("#customer_remove_" + index).css("right", "0");
        this.$refs[cus_name][0].inputValue = this.items[index].cus_detail_id;
      }
    }
  },

  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("general/fetchtaglist");
    store.dispatch(
      "general/getallcustomfilter",
      JSON.stringify({
        report_type: routeTo.meta.title
      })
    );
    getPageSalesByProducts(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    typeof this.$refs.runreport != "undefined"
      ? this.$refs.runreport.hide()
      : "";
    typeof this.$refs.run != "undefined" ? this.$refs.run.hide() : "";
    getPageSalesByProducts(routeTo, next);
  },
  computed: {
    ...mapState({
      customer_filter_list: state => state.general.customer_filter_list,
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      taglist: state => state.general.taglist,
      export: state => state.reports.export,
      reportsfilter: state => state.general.reportsfilter
    }),
    ...mapGetters(["orgCurrencySymbol", "reporting_tags", "orgCurrency"]),
    selectedfilter: {
      get() {
        return this.$store.state.general.selectedfilter;
      },
      set(val) {
        this.$store.state.general.selectedfilter = val;
      }
    },
    oldRoute: {
      get() {
        return this.$store.state.general.oldRoute;
      },
      set(val) {
        this.$store.state.general.oldRoute = val;
      }
    }
  }
};
</script>
<!--  Sales by Item style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
</style>  